import { enumHierarchyTypes, enumXMLType } from "../constants";
import { MeasureText } from "../utils/MeasureText";
import { MeasureTextHeight } from "../utils/MeasureTextHeight";
import { SVG_DrawText } from "../utils/SVG_DrawText";
import { TruncateText } from "../utils/TruncateText";
import { XML_AddLinkToPDF } from "../utils/XML_AddLinkToPDF";
import { XML_AddLinkToPPT } from "../utils/XML_AddLinkToPPT";
import { XML_DrawText } from "../utils/XML_DrawText";
import { XML_ScaleAndShiftX } from "../utils/XML_ScaleAndShiftX";
import { XML_ScaleAndShiftY } from "../utils/XML_ScaleAndShiftY";
import { Globals } from "./Globals";
import { QTextEditBase } from "./QTextEditBase";

export // Box Cell Object
class QBoxCellObj extends QTextEditBase {
  constructor() {
    super();
    this.fParentElement = null;
    this.fSourceObj = null;
    this.fFieldDef = null;
    this.fSubtype = null;
  }

  InitBoxCellObj(boxCell, fieldDef, boxCellObj, objectType, elementList) {
    this.fAltElementList = elementList;
    this.fParentElement = boxCell;
    this.fFieldDef = fieldDef;
    this.fSourceObj = boxCellObj; // {'Name':'','PersonID':''}
    this.fSubtype = objectType;
    var curDoc = Globals._wsMgr.GetDoc();
    if (curDoc.GetHierarchyType() === enumHierarchyTypes.positions)
      this.SetContent(this.fSourceObj["Title"]);
    else this.SetContent(this.fSourceObj["Name"]);
    this.SetDataObj();
    //this.SetDisplayContent(boxCellObj.fFieldObj);
  }

  TEGetFontString() {
    return this.fParentElement.TEGetFontString();
  }

  DoRenderElement(drawBuffer) {
    var ctx = drawBuffer.getContext("2d");
    this.fClippedRegionCoords = this.fParentElement.fClippedRegionCoords;
    this.fTheClippedRegion = this.fParentElement.fTheClippedRegion;

    if (this.fParentElement.TreatAsObject()) {
      this.fEnabled = true;
      this.TEDrawText(
        ctx,
        this.TEGetContentToRender(),
        this.GetPositionX(),
        this.GetPositionY(),
        this.fParentElement.TEGetFontColor(),
        -1,
        -1,
        "left",
        true,
        true,
        false,
        true
      );
    } else this.fEnabled = false;
  }

  DoAltRender(altCanvas) {
    var x = this.GetPositionX();
    var y = this.GetPositionY();
    var textColor = this.TEGetFontColor();
    var fontFamily = this.fParentElement.GetFontName();
    var fontSize = this.fParentElement.GetFontSize();
    var bold = this.fParentElement.GetFontBold();
    var italic = this.fParentElement.GetFontItalic();
    var underline = this.GetFontUnderlined();
    var alignment = this.TEGetAlignment();
    var vAlignment = this.TEGetVAlignment();
    var clipRect = this.fParentElement.TEAltGetClipRect();
    var layer = this.GetLayer();
    var altCanvasType = altCanvas.GetCanvasType();
    var altCanvasElement = altCanvas.GetCanvasElement();
    y += 2; // WHY IS THIS NECESSARY?
    if (altCanvasType == "SVG") {
      SVG_DrawText(
        this.fContent,
        x,
        y,
        textColor,
        fontFamily,
        fontSize,
        bold,
        italic,
        underline,
        "left",
        "top",
        clipRect,
        altCanvasElement
      );
    } else {
      clipRect.fLeft = this.GetPositionX();
      var docType = altCanvasElement.GetDocType();
      // this is a bit weird... v alignment has already been handled by PositionElements. Need to make sure
      // altcanvas positioning does not disrupt this. PPT needs it to be set to bottom for prior positioning to work
      // and PDF needs top.
      if (docType === enumXMLType.PDF) {
        var vAlign = "top";
      } else {
        vAlign = "bottom";
        y -= 3; // eh, why not?
      }
      XML_DrawText(
        this.fContent,
        x,
        y,
        textColor,
        fontFamily,
        fontSize,
        bold,
        italic,
        underline,
        "left",
        vAlign,
        clipRect,
        altCanvasElement,
        layer
      );
      var x1 = x + this.GetWidth();
      var y1 = y + this.GetHeight();
      var artBookmark = this.GetARTBookmark();
      if (docType === enumXMLType.PDF) {
        x = XML_ScaleAndShiftX(x, altCanvasElement, layer);
        y = XML_ScaleAndShiftY(y, altCanvasElement, layer);
        x1 = XML_ScaleAndShiftX(x1, altCanvasElement, layer);
        y1 = XML_ScaleAndShiftY(y1, altCanvasElement, layer);

        y = altCanvasElement.ConvertY(y);
        y1 = altCanvasElement.ConvertY(y1);
        XML_AddLinkToPDF(x, y, x, y, x1, y1, x1, x1, altCanvasElement, artBookmark);
      } else XML_AddLinkToPPT(artBookmark, altCanvasElement);
    }
  }

  // Do not want the separators to show underline
  GetFontUnderlined() {
    return this.fParentElement.GetFontUnderlined(true);
  }

  GetARTBookmark() {
    if (this.fIsLabel) return null;
    var gWSMgr = Globals._wsMgr;
    var scm = gWSMgr.GetSubChartMgr();
    var curDoc = gWSMgr.GetDoc();
    var o = curDoc.GetObjDB();
    var aClass = o.GetClassByName("Box");
    var personIDDef = scm.GetRecordIDField(aClass); // todo: will positions use GetPersonIDField? may cause issues...
    var dataObj = aClass.FindObject(personIDDef, this.GetRefValue(), true);
    if (dataObj == null) return null;
    var scID = scm.FindSubChartID(dataObj, true);
    if (scID == null) return null;
    var parentBox = this.fParentElement.fParentBox;
    return parentBox.fParentPanel.GetLinkBookmark(scID);
  }

  TEGetAlignment() {
    return this.fParentElement.TEGetAlignment(false);
  }

  GetWidth() {
    var fontString = this.TEGetFontString();
    var content = this.TEGetContentToRender();
    return MeasureText(content, fontString);
  }

  TEGetContentToRender() {
    var fontString = this.TEGetFontString();
    var content = this.fContent;
    var availableWidth = this.GetAvailableWidth() - this.GetSeparatorWidth();
    return TruncateText(content, fontString, availableWidth);
  }

  GetAvailableWidth() {
    return this.fParentElement.GetWidthPositionX() - this.GetPositionX();
  }

  GetSeparatorWidth() {
    return MeasureText(this.GetSeparator(), this.TEGetFontString());
  }

  GetHeight() {
    // +2 increment taken from QTextEditBase.TEDrawText
    // QBoxCellObj height is synonymous with BoxCell rowHeight
    return MeasureTextHeight(this.TEGetFontString(), this.fParentElement.GetFontSize()) + 2;
  }

  // ---------------------------------------------------------
  TEGetFontColor() {
    return this.fParentElement.TEGetFontColor();
  }

  GetRefValue() {
    var curDoc = Globals._wsMgr.GetDoc();
    if (curDoc.GetHierarchyType() === enumHierarchyTypes.positions)
      return this.fSourceObj["AuxPositionID"];
    else return this.fSourceObj["AuxPersonID"];
  }

  GetQueryRefValue() {
    var curDoc = Globals._wsMgr.GetDoc();
    if (curDoc.GetHierarchyType() === enumHierarchyTypes.positions)
      return this.fSourceObj["PositionID"];
    else return this.fSourceObj["PersonID"];
  }

  //TODO: hmm... (an aux rec will not show under another aux rec)
  // Need this now that navigation is to other auxes rather than supervisors...
  GetAuxRefValue() {
    return this.fSourceObj["isAux"];
  }

  GenerateAdditionalCmdParameters() {
    this.AddCmdParameter("targetID", this.GetRefValue());
    this.AddCmdParameter("auxRef", this.GetAuxRefValue());
    this.AddCmdParameter("treeID", this.GetTreeRefValue());
    this.AddCmdParameter("queryID", this.GetQueryRefValue());
  }

  SetDataObj() {
    var parentEle = this.fParentElement;
    if (parentEle == null) return;
    var parentLayout = parentEle.GetLayout();
    var doc = parentLayout.GetDocRef();
    var objDB = doc.GetObjDB();
    var boxClass = objDB.GetClassByName("Box");

    if (doc.GetHierarchyType() === enumHierarchyTypes.positions) var recordIDField = "PositionID";
    else recordIDField = "PersonID";
    var personIDField = boxClass.GetFieldDefByID(recordIDField);
    var dataObj = boxClass.FindObject(personIDField, this.GetRefValue(), true);
    this.fDataObj = dataObj;
  }

  GetDataObj() {
    return this.fDataObj;
  }

  GetElementIndex(id) {
    if (this.fAltElementList != null) var elementsList = this.fAltElementList;
    else elementsList = this.fParentElement.fElements;
    for (var i = 0; i < elementsList.length; i++) {
      var anElement = elementsList[i];
      if (anElement.GetRefValue() === id) return i;
    }
    return -1;
  }

  GetSeparator() {
    var myIdx = this.GetElementIndex(this.GetRefValue());
    if (this.fAltElementList != null) var elementsList = this.fAltElementList;
    else elementsList = this.fParentElement.fElements;
    if (myIdx === elementsList.length - 1 || this.fIsLabel) return "";
    else if (elementsList.length === 2) return " & ";
    else if (myIdx < elementsList.length - 2) return ", ";
    else return ", & ";
  }

  SetContent(content) {
    this.fContent = content;
  }

  GetCursor() {
    return this.fIsLabel ? "default" : "pointer";
  }

  GetTreeRefValue() {
    return this.fSourceObj["treeID"];
  }

  IsHyperLink() {
    return false;
  }
}
